var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20760",
    "data-name": "Raggruppa 20760",
    transform: "translate(-1453.001 -620)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32892",
    "data-name": "Tracciato 32892",
    d: "M36.028,30.647a7.5,7.5,0,1,1-7.5-7.5,7.5,7.5,0,0,1,7.5,7.5",
    transform: "translate(1431.973 596.853)",
    fill: "#3260ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32893",
    "data-name": "Tracciato 32893",
    d: "M22.517,16.181H20V13.664A3.714,3.714,0,0,1,22.517,10v1.461a2.319,2.319,0,0,0-1.236,2.2h1.236Zm4.091,0H24.091V13.664A3.714,3.714,0,0,1,26.608,10v1.461a2.319,2.319,0,0,0-1.236,2.2h1.236Z",
    transform: "translate(1437 614)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.1c8b46224b7cf1349c51b3e555743a78.svg";
export { ForwardRef as ReactComponent };